export enum AuctionTypeEnum {
  Bidding = 'bidding',
  BuyNow = 'buyNow',
  PriceProposal = 'priceProposal'
}
